import { render, staticRenderFns } from "./OneCard.vue?vue&type=template&id=7c258e2c&scoped=true"
import script from "./OneCard.vue?vue&type=script&lang=js"
export * from "./OneCard.vue?vue&type=script&lang=js"
import style0 from "./OneCard.vue?vue&type=style&index=0&id=7c258e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c258e2c",
  null
  
)

export default component.exports